import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../authentication/authenticationService';
import { PaytronBackendService } from '../paytron-backend/paytron-backend.service';
import 'rxjs/add/operator/do';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService, private backendService: PaytronBackendService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).do(
      (data) => {
        if (data instanceof HttpResponse) {
          let res: HttpResponse<any> = data;
          let newToken: string = res.headers.get('token');
          if (newToken) {
            this.authenticationService.token = newToken;
          }
        }
      },
      (err: HttpErrorResponse) => {
        if (err.status == 401) {
          this.authenticationService.requestInterceptedSource.next(err.status);
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/authentication/refreshTokenInterceptor.ts